import { Plugin } from "prosemirror-state";

import { Extension } from "../extension";

export default class FilePaste extends Extension {
	get name() {
		return "file-paste";
	}
	get plugins() {
		const extension = this;
		const filePastePlugin = new Plugin({
			props: {
				handlePaste(_view, event, _slice) {
					if (!(event instanceof ClipboardEvent)) return false;
					if (!event.clipboardData || !event.clipboardData.files || !event.clipboardData.files.length) return false;

					for (let i = 0; i < event.clipboardData.items.length; i += 1) {
						if (event.clipboardData.items[i].kind === "string") return false;
					}

					if (extension.options.upload) {
						extension.options.upload(Array.from(event.clipboardData.files));
						return true;
					}
					return false;
				},
			},
		});
		return [filePastePlugin];
	}
}
